export default {"src":"/_next/static/media/passkey-white.fb77285a.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};